import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SharedModule } from '@Shared/shared.module';

@Component({
    selector: 'display-lv',
    template: `<div class="label-title" [ngClass]="{'text-uppercase': isUpperCase=='true'}">{{label}} </div>
    <div class="label-content">{{value ? value : '-' }}</div>`,
    imports: [CommonModule]
})
export class DisplayLabelValueComponent {

    @Input() label;
    @Input() value;
    @Input() isUpperCase;

}